import './Navbar.css'

import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useMobile from '../hooks/useMobile';
import NavbarLogo from '../img/logo-txt-black.svg';
import Hamburger from '../img/hamburger.svg';

function NavigationElement(props: { text: string, link: string }) {
    const [currentLocation, setCurrentLocation] = useState(useLocation().pathname);
    const navigate = useNavigate();
    return (
        <div onClick={() => navigate(props.link)} className='Navbar__navigation__element'>
            <a>{props.text}</a>
            <div className='Navbar__navigation__element__underline' style={{display: props.link === currentLocation ? 'block' : 'none'}}></div>
        </div>
    )
}

function HamburgerNavigationElement(props: { text: string, link: string }) {
    const navigate = useNavigate();
    return (
        <div onClick={() => navigate(props.link)} className='Navbar__hamburger__navigation__element'>
            <a>{props.text}</a>
        </div>
    )
}

export default function Navbar() {
    const isMobile = useMobile();
    const navigationElements = [
        {
            text: 'Strona główna',
            link: '/'
        },
        {
            text: 'Upowszechnianie',
            link: '/upowszechnianie'
        },
        {
            text: 'Wycieczki',
            link: '/wycieczki'
        },
        {
            text: 'Rezultaty',
            link: '/rezultaty'
        }
    ]

    function handleHamburgerClick() {
        const hamburgerContainer = document.getElementById('hamburger__container');
        if (hamburgerContainer) {
            if (hamburgerContainer.style.display === 'block') {
                hamburgerContainer.style.display = 'none';
            } else {
                hamburgerContainer.style.display = 'block';
            }
        }
    }
    
    return (
        <>
            <div className='Navbar__container'>
                <div className='TopBar'>
                    <div className='TopBar__text'>
                        Zespół Szkół Ponadpodstawowych w Krośnie Odrzańskim
                    </div>
                </div>
                <div className='Navbar'>
                    <div className='Navbar__logo'>
                        <img src={NavbarLogo} alt='Logo' />
                    </div>
                    {isMobile ? <div className='Navbar__hamburger' onClick={() => handleHamburgerClick()}>
                        <img src={Hamburger} width={'24px'}></img>
                    </div>
                    :
                    <div className='Navbar__navigation'>
                        {
                            navigationElements.map((element, index) => {
                                return <NavigationElement key={index} text={element.text} link={element.link} />
                            })
                        }
                    </div>}
                </div>
            </div>
            {isMobile ?
            <div className='Navbar__hamburger__container' id='hamburger__container'>
                {
                    navigationElements.map((element, index) => {
                        return <HamburgerNavigationElement key={index} text={element.text} link={element.link} />
                    })
                }
            </div>
            : null}
        </>
    )
}